import dayjs from "dayjs";

// Payment status for a CDN / Proforma row, worded like the invoice list
// (Paid, Partially Paid, Unpaid, Overdue, Cancelled). A CDN isn't billed yet,
// so "paid" here means the advances received cover the whole Grand Total.
//   label        — the status text
//   overdueDays  — whole days past the due date (Overdue only)
//   detail       — small second line ("Paid AED 40.00 of 105.00"), if any
export const getDocPaymentStatus = (row = {}) => {
  const status = String(row.status || "active").toLowerCase();
  if (status === "cancelled") return { label: "Cancelled", overdueDays: 0, detail: "" };
  // Once converted, the money is tracked on the invoice(s), not here.
  if (status === "converted" || status === "fully_returned") {
    return { label: "On invoice", overdueDays: 0, detail: "" };
  }
  const total = Number(row.grand_total) || 0;
  const balance = Number(row.balance_due) || 0;
  const paid = Number(row.advance_unapplied) || 0;
  if (!(total > 0)) return { label: "-", overdueDays: 0, detail: "" };
  if (balance <= 0.009) return { label: "Paid", overdueDays: 0, detail: "" };
  const detail = paid > 0 ? `Paid ${paid.toFixed(2)} of ${total.toFixed(2)}` : "";
  if (row.due_date && dayjs(row.due_date).isBefore(dayjs(), "day")) {
    const days = Math.max(0, dayjs().startOf("day").diff(dayjs(row.due_date).startOf("day"), "day"));
    return { label: "Overdue", overdueDays: days, detail };
  }
  if (paid > 0) return { label: "Partially Paid", overdueDays: 0, detail };
  return { label: "Unpaid", overdueDays: 0, detail: "" };
};

// Column filter choices — same wording as the invoice list.
export const DOC_PAYMENT_STATUS_FILTER_OPTIONS = [
  { label: "Pending (all outstanding)", value: "Pending" },
  { label: "Unpaid", value: "unpaid_not_due" },
  { label: "Partially Paid", value: "partial_not_due" },
  { label: "Overdue", value: "Overdue" },
  { label: "Paid", value: "Paid" },
  { label: "Cancelled", value: "Cancelled" },
];
